<template>
    <div class="front-ware">
        <div class="ware-map" id="ware-map" ref="ware-map"></div>
        <div class="ware-search">
            <div class="search-box-title">营业网点查询</div>
            <addressCascader
                v-model="searchData.address"
                :minLayers="3"
                placeholder="请选择省市区"
            ></addressCascader>
            <el-input
            class="keyward-input"
            v-model="searchData.addressKeyword"
            placeholder="请输入地址关键字"
            ></el-input>
            <button type="primary" class="search-btn" @click="search">查询</button>
            <div v-show="noWarehouse" class="no-warehouse">暂无网点</div>
            <div class="network-list">
                <div
                :class="{'network-box':true,'network-box-clicked':clicked === key}"
                v-for="(item, key) in networkList"
                :key="key"
                @click="clickNet(key)">
                    <div class="network-name">
                        <div class="name-no">{{key+1}}</div>
                        <span>{{item.deptName}}</span>
                    </div>
                    <div class="network-address">{{item.fullAddress || item.deptAddr}}</div>
                    <div class="network-phone">{{item.deptMobile}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import addressCascader from './addressCascader/index.vue';
import { Message } from 'element-ui';
import config from '@/config/env.js';
export default {
    metaInfo: {
        title: '营业网点-安得智联'
    },
    name: 'warehouse',
    data() {
        return {
            ak: 'uXRnW5KnsRHsIseRVNRrAvtnBWd2sVHR',
            isMobile: this.COMMON.isMobile,
            mymap: {},
            BMap: null,
            searchData: {
                address: [],
                addressKeyword: ''
            },
            networkList: [],
            clicked: -1,
            clickedPoint: {},
            mark: {},
            noWarehouse: false
        };
    },
    components: {
        addressCascader
    },
    methods: {
        mymapfun() {
            this.mymap = new this.BMap.Map('ware-map');
            this.mymap.centerAndZoom(
                new this.BMap.Point(113.211235, 22.907162),
                12
            );
            this.mymap.enableScrollWheelZoom(true);
        },
        search() {
            const that = this;
            let points = [];
            const [ provinceCode, cityCode, districtCode ] = this.searchData.address;
            if (!provinceCode || !cityCode || !districtCode) {
                Message.warning('请选择省市区');
                return;
            }
            const params = {
                provinceCode,
                cityCode,
                districtCode,
                searchSiteName: this.searchData.addressKeyword
            };
            this.$http.get(`${config.reqiestUrl}/api-portal/public/portal/network/list`,{params}).then(res => {
                if (res && res.data && res.data.data) {
                    this.networkList = res.data.data;
                    if (this.networkList.length === 0) {
                        this.noWarehouse = true;
                        return;
                    }
                    this.noWarehouse = false;
                    this.networkList.forEach(item => {
                        let point = new that.BMap.Point(
                            item.longitude,
                            item.latitude
                        );
                        points.push(point);
                    });
                    that.mymap.setViewport(points); //根据点自动调整缩放比例
                    that.showPoints(that.networkList);
                }
            });
        },
        clickNet(key) {
            let lastPointexit = false;
            if (Object.keys(this.clickedPoint).length>0) {
                lastPointexit = true;
            }
            this.clicked = key;
            this.clickedPoint = this.networkList[key];
            let point = {
                ...this.clickedPoint,
                id: key+1,
                point: new this.BMap.Point(
                    this.clickedPoint.longitude,
                    this.clickedPoint.latitude
                )
            };
            this.addselectPoint(lastPointexit, point);
        },
        showPoints(pointsOn) {
            const that = this;
            function ComplexCustomOverlay(point, text) {
                this._point = point;
                this._text = text;
            }
            //中心点下移，避开搜索框
            if (that.isMobile) {
                var curPix = this.mymap.pointToPixel(this.mymap.getCenter());
                var newPix = new that.BMap.Pixel(curPix.x, curPix.y - 40);
                var newCenter = this.mymap.pixelToPoint(newPix);
                this.mymap.setCenter(newCenter);
            }
            //添加点
            ComplexCustomOverlay.prototype = new that.BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map) {
                this._map = map;
                var icon = require('../../images/icon/network_map.png');
                var div = (this._div = document.createElement('div'));
                div.style.cssText = 'background:' + 'url(' + icon + ') no-repeat;' +
                                    'position:absolute;color:#ffffff;text-align:center;' +
                                    'background-size:100%;font-size:16px;' +
                                    'z-index:' + that.BMap.Overlay.getZIndex(this._point.lat) +
                                    ';height:' + (that.isMobile ? '22px' : '48px') +
                                    ';width:' + (that.isMobile ? '18px' : '44px') +
                                    ';padding-top:' + (that.isMobile ? '1px' : '11px');
                div.appendChild(document.createTextNode(this._text));
                that.mymap.getPanes().markerPane.appendChild(div);
                return div;
            };
            ComplexCustomOverlay.prototype.draw = function() {
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                this._div.style.left = (pixel.x - 14) / 100 + 'rem';
                this._div.style.top = (pixel.y - 36) / 100 + 'rem';
            };
            this.mymap.clearOverlays();
            var myCompOverlay = [];
            pointsOn.map((item, index) => {
                var pt = new this.BMap.Point(
                    item.longitude,
                    item.latitude
                );
                myCompOverlay[index] = new ComplexCustomOverlay(
                    pt,
                    index + 1
                );
                that.mymap.addOverlay(myCompOverlay[index]);
            });
        },
        addselectPoint(lastPointexit, clicked) {
            const that = this;
            function BlueCustomOverlay(point, text) {
                this._point = point;
                this._text = text;
            }
            //添加点
            BlueCustomOverlay.prototype = new that.BMap.Overlay();
            BlueCustomOverlay.prototype.initialize = function(map) {
                this._map = map;
                var icon = require('../../images/icon/network_select.png');
                var backicon = require('../../images/icon/select_bg.png');
                var box = (this._div = document.createElement('div'));
                var div = document.createElement('div');
                var top = document.createElement('div');
                top.innerHTML =
                '<div class=\'network-name\'><span>' + 
                    clicked.deptName +
                '</span></div>'+
                '<div class=\'network-address\'>' + (clicked.fullAddress || clicked.deptAddr) +'</div>'+
                '<div class=\'network-phone\'>'+clicked.deptMobile+'</div>';
                box.style.cssText = 'position:absolute;' +
                                    'z-index:' + (that.BMap.Overlay.getZIndex(this._point.lat)+10000);
                top.style.cssText = 'background:url('+backicon+');width:350px;height:160px;' +
                                    'position:relative;bottom:164px;left:-153px;padding:25px 25px;box-sizing:border-box';
                div.style.cssText = 'background:' + 'url(' + icon + ') no-repeat;' +
                                    'position:absolute;color:#ffffff;text-align:center;' +
                                    'background-size:100%;font-size:16px;' +
                                    ';height:' + (that.isMobile ? '22px' : '48px') +
                                    ';width:' + (that.isMobile ? '18px' : '44px') +
                                    ';padding-top:' + (that.isMobile ? '1px' : '11px');
                div.appendChild(document.createTextNode(this._text));
                box.appendChild(div);
                box.appendChild(top);
                that.mymap.getPanes().markerPane.appendChild(box);
                return box;
            };
            BlueCustomOverlay.prototype.draw = function() {
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                this._div.style.left = (pixel.x - 14) / 100 + 'rem';
                this._div.style.top = (pixel.y - 36) / 100 + 'rem';
            };
            if (lastPointexit) {
                this.mymap.removeOverlay(this.mark);
            }
            this.mark = new BlueCustomOverlay(clicked.point, clicked.id);
            this.mymap.addOverlay(this.mark);
            this.mymap.setCenter(clicked.point);
        }
    },
    mounted() {
        this.BMap = window.BMap;
        this.mymapfun();
    }
};
</script>
<style lang="less">
.front-ware {
    min-height: 4.5rem;
    position: relative;
    .ware-map {
        width: 100%;
        height: 8.22rem;
        overflow: hidden;
        float: right;
    }
    .ware-search {
        position: absolute;
        background: #fff;
        top: 0.2rem;
        right: 3.6rem;
        width: 3.2rem;
        height: 7.82rem;
        box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);
        padding: 0.2rem 0.2rem 0;
        box-sizing: border-box;
    }
    .search-box-title {
        border-left: #FF8B00 3px solid;
        font-size: .2rem;
        color: #333333;
        font-weight: 500;
        padding-left: 0.1rem;
        margin-bottom: 0.2rem;
    }
    .el-input__inner {
        border: 0;
        background: #F6F6F6;
        border-radius: 0;
    }
    .keyward-input {
        margin-top: 0.1rem;
    }
    .search-btn {
        width: 100%;
        height: 0.42rem;
        margin-top: 0.2rem;
        margin-bottom: 0.1rem;
        background-color: #ff8b00;
        color: #ffffff;
        font-size: 16px;
        border: 0;
        cursor: pointer;
        &[disabled] {
            background-color: #999;
        }
    }
    .network-list {
        overflow-y: auto;
        height: 550px;
    }
    .network-box {
        padding: 0.11rem 0;
        font-size: 14px;
        color: #888888;
    }
    .network-box-clicked {
        background: #f5f5f5;
    }
    .network-box:hover {
        background: #f5f5f5;
    }
    .network-name {
        font-size: 16px;
        color: #2876FF;
        font-weight: 600;
        display: flex;
        align-items: center;
    }
    .name-no {
        font-size: 14px;
        font-weight: 500;
        line-height: 0.22rem;
        text-align: center;
        height: 0.25rem;
        width: 0.22rem;
        color: #FFFFFF;
        margin-right: 0.1rem;
        background: url(../../images/icon/network.png) center no-repeat;
    }
    .network-address,.network-phone {
        display: flex;
        align-items: center;
        margin-top: 0.1rem;
    }
    .network-address::before {
        content: url(../../images/icon/position.png);
        height: .17rem;
        width: .14rem;
        margin-right: .14rem;
    }
    .network-phone::before {
        content: url(../../images/icon/phone.png);
        height: .17rem;
        width: .14rem;
        margin-right: .14rem;
    }
    .no-warehouse {
        color: #999;
        font-size: 12px;
        text-align: center;
        margin-top: 50px;
    }
}
</style>